import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {useParams} from "react-router-dom";
import Role from "../../../inc/Role";
import {Config} from '../../../Config'
import * as Utils from "../../../inc/Utils";
import Select from 'react-select'
import CampaignTemplateEditProject from "./CampaignTemplateEditProject";
import CampaignTemplateEditPromotion from "./CampaignTemplateEditPromotion";
import CampaignTemplateEditMasterURL from "./CampaignTemplateEditMasterURL";
import CampaignTemplateEditSpecial from "./CampaignTemplateEditSpecial";

export default function CampaignTemplateEdit() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let campaignTemplateId = decode.id;

    let [type, setType] = React.useState(null);
    let [typeId, setTypeId] = React.useState(null);
    let [name, setName] = React.useState(null);
    let [resView, setResView] = React.useState(null);

    React.useEffect(() => {
        (async function() {
            try {
                const resType = await Utils.getType();
                setType(resType);

                if(campaignTemplateId) {
                    const resView = await getView(campaignTemplateId);
                    setResView(resView);
                    setName(resView.name);
                    setTypeId(resType.filter(e => e.id === resView.typeId)[0]);
                }

            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getView(id) {
        const response = await fetch(Config.url.API_URL +'/api/campaignTemplate/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const handleChange = (e) => {
        setName(e.target.value);
    };

    const onChangeTypeId = async (obj) => {
        setTypeId(obj);
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Campaign Template</div>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">ชื่อ Campaign Template <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="name" maxLength={100} onChange={handleChange} defaultValue={name} />
                            </div>

                            <div className="col-12">
                                <label htmlFor="typeIed" className="form-label">Type <span className="text-danger">*</span></label>
                                <Select
                                    classNamePrefix="form-select-search"
                                    options={type}
                                    onChange={(event) => onChangeTypeId(event)}
                                    value={typeId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            {
                                typeId && typeId.id === Utils.GENERATE_TYPE_PROJECT ? <CampaignTemplateEditProject typeId={typeId} data={resView} name={name} /> : ''
                            }
                            {
                                typeId && typeId.id === Utils.GENERATE_TYPE_PROMOTION ? <CampaignTemplateEditPromotion typeId={typeId} data={resView} name={name} /> : ''
                            }
                            {
                                typeId && typeId.id === Utils.GENERATE_TYPE_MASTER_URL ? <CampaignTemplateEditMasterURL typeId={typeId} data={resView} name={name} /> : ''
                            }
                            {
                                typeId && typeId.id === Utils.GENERATE_TYPE_SPECIAL ? <CampaignTemplateEditSpecial typeId={typeId} data={resView} name={name} /> : ''
                            }
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 